import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',

    ns: [
      'common',
      'analysis',
      'pages',
      'discovery',
      'docs',
      'ytdashboard',
      'mostviewed',
      'keywords',
      'monetization'
    ], 
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
      skipOnVariables: false
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: false,
    },

    react: {
      useSuspense: false,
      returnObjects: false
    },

    saveMissing: false,
    fallbackNS: 'common',
    
    pluralSeparator: '_',
    contextSeparator: '_',
    keySeparator: '.',
    nsSeparator: ':',
    
    returnEmptyString: false,
    returnNull: false,
    
    cache: {
      enabled: true,
      prefix: 'i18next_res_',
      expirationTime: 7 * 24 * 60 * 60 * 1000,
      versions: {}
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;